import { ColumnInfo } from '../types/ColumnInfo';
import { ICON_PROPERTY_NAME, NAME_PROPERTY_NAME } from '../constants';

const DEFAULT_COLUMN_MIN_WIDTH = 96;
const DEFAULT_COLUMN_MAX_WIDTH = 240;

// The reason that we have value of map as `() => ColumnInfo` instead of `ColumnInfo`
// because it can use localized strings which needs to be resolved when needed instead
// of when the code initializes
type ColumnInfoMapping = { [key: string]: () => ColumnInfo };

const folderSelectorColumns: ColumnInfoMapping = Object.freeze<ColumnInfoMapping>({
    [ICON_PROPERTY_NAME]: () => ({
        key: ICON_PROPERTY_NAME,
        name: '',
        minWidth: 20,
        maxWidth: 20,
    }),
    [NAME_PROPERTY_NAME]: () => ({
        key: NAME_PROPERTY_NAME,
        name: 'Name',
        minWidth: DEFAULT_COLUMN_MIN_WIDTH,
        maxWidth: DEFAULT_COLUMN_MAX_WIDTH,
    }),
});

export function getFolderSelectorColumnInfo(key: string): ColumnInfo | null {
    const columns = getFolderSelectorColumns();
    return columns[key] ? columns[key]() : null;
}

function getFolderSelectorColumns(): ColumnInfoMapping {
    return folderSelectorColumns;
}
